/* eslint-disable no-restricted-imports */
import { createStitches } from '@stitches/react';
import { ValueOf } from 'type-fest';

import { colors } from './tokens/colors';
import { fontSizes } from './tokens/font-sizes';

export type { CSS, VariantProps } from '@stitches/react';
export type Color = ValueOf<typeof theme.colors>;

const isExtensionBuild =
  // eslint-disable-next-line node/no-process-env
  (process.env.NEXT_PUBLIC_PRODUCT as string | undefined) ===
  'paperpal-edit-for-extension';

export const { css, getCssText, globalCss, keyframes, styled, theme } =
  createStitches({
    ...(isExtensionBuild ? { root: null } : {}),
    media: {
      sm: '(max-width:767px)',
      md: '(min-width: 768px) and (max-width:1023px)',
      lg: '(min-width: 1024px)',
      smallHeight: '(max-height:520px)',
      maxHeight570: '(max-height:570px)',
      maxHeight700: '(max-height:700px)',
      maxWidth300: '(max-width:300px)',
      smAndShort: '(max-width: 320px) and (max-height: 621px)',
    },
    theme: {
      colors,
      fonts: {
        sansSerif: '"IBM Plex Sans", Arial, "Segoe UI", Tahoma, sans-serif',
        serif:
          '"IBM Plex Serif", -apple-system, BlinkMacSystemFont, Georgia, serif',
        inter: '"Inter", Arial, "Segoe UI", Tahoma, sans-serif',
      },
      fontSizes,
      fontWeights: {
        normal: '400',
        medium: '500',
        semiBold: '600',
        bold: '700',
      },
      shadows: {
        border: 'inset 0px 0px 0px 1px',
        shadow1: '0px 4px 8px -6px',
        shadow2: '0px 4px 12px -6px',
        shadow3: '0px 4px 22px -10px',
      },
    },
  });
